import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const getInitialModule = async <T extends Action<ACTION_TYPE.GET_INITIAL_MODULE>>({
  uniqueId,
  userId,
  language,
  country
}: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId,
        userId,
        language,
        country
      },
      type: ACTION_TYPE.GET_INITIAL_MODULE
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { user, module } = body.data

    return {
      user,
      module
    }
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_INITIAL_MODULE, {
      uniqueId,
      userId,
      language
    })
    throw err
  }
}

export const getNextModule = async <T extends Action<ACTION_TYPE.GET_NEXT_MODULE>>({ uniqueId, moduleId }: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId,
        moduleId
      },
      type: ACTION_TYPE.GET_NEXT_MODULE
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { module } = body.data

    return {
      module
    }
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_NEXT_MODULE, {
      uniqueId,
      moduleId
    })
    throw err
  }
}

export const getPreviousModule = async <T extends Action<ACTION_TYPE.GET_PREVIOUS_MODULE>>({ uniqueId }: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId
      },
      type: ACTION_TYPE.GET_PREVIOUS_MODULE
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { module } = body.data

    return {
      module
    }
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_PREVIOUS_MODULE, {
      uniqueId
    })
    throw err
  }
}
